import PropTypes from 'prop-types';
import React from 'react';
import {BreadcrumbsItem} from 'react-breadcrumbs-dynamic';
import {withTranslation} from 'react-i18next';
import BaseListContainer from '../baseContainers/BaseListContainer';
import ActionLink from '../components/ActionLink';
import CriteriaRadioButtonComponent from '../components/criteria/CriteriaRadioButtonComponent';
import CriteriaTextComponent from '../components/criteria/CriteriaTextComponent';
import DriverModel from '../model/DriverModel';
import {baseReportCsv, baseReportPdf, baseXLSXReport} from '../report/ReportUtils';
import DriverService from '../services/DriverService';
import DriverDialog from './DriverDialog';

class DriverList extends BaseListContainer {
    constructor(props) {
        super(props, new DriverService());
        this.state = {
            list: [],
            selectedList: [],
            selectAll: false,
            loading: true,
            size: 0,
            first: 0,
            criteria: this.getCleanSearchCriteria(),
            filters: {},
            statusOptions: [],
            roleTypeOptions: [],
        };
        this.handleOpenNewDialog = this.handleOpenNewDialog.bind(this);
        this.handleOpenDialog = this.handleOpenDialog.bind(this);
        this.handleCloseDialog = this.handleCloseDialog.bind(this);
    }
    getDataKey() {
        return 'sapId';
    }

    getListTitle() {
        return 'driver.listTitle';
    }
    updateSearchCriteria(criteria) {
        return {
            lastName: criteria.lastName,
            pesel: criteria.pesel,
            documentNumber: criteria.documentNumber,
            own: criteria.own,
            firstResult: criteria.firstResult,
            maxResults: criteria.maxResults,
            sortField: criteria.sortField,
            sortAsc: criteria.sortAsc,
        };
    }

    getCleanSearchCriteria() {
        return {
            lastName: '',
            pesel: '',
            documentNumber: '',
            own: undefined,
            firstResult: 0,
            maxResults: 10,
            sortField: 'lastName',
            sortAsc: true,
        };
    }

    initializeFromBackend() {
        const {t} = this.props;
        this.enumService
            .getEnumList('InvoiceStatus', t)
            .then((statusOptions) => {
                if (this._isMounted) {
                    this.setState({
                        statusOptions,
                    });
                }
            })
            .catch(() => {
                this.showErrorMessage(t('error.statusListError'));
            });
    }

    handleValidForm() {
        this.getList();
    }
    onAfterGetList() {
        this.unblockUi();
    }
    getCriteriaName() {
        return 'driver-list-sc';
    }

    getContainerListName() {
        return 'driver-list-container';
    }

    translate(key) {
        const {t} = this.props;
        return t(key);
    }
    generateReport(format) {
        const {t, lazy} = this.props;
        //const list = this.state.selectedList;
        const list = (this.hasFilter() && this.state.selectAll && lazy === false )? this.processData() : this.state.selectedList;
        const columns = [
            {header: t('driver.firstName'), field: 'firstName'},
            {header: t('driver.lastName'), field: 'lastName'},
            {header: t('driver.pesel'), field: 'pesel'},
            {header: t('driver.documentNumber'), field: 'documentNumber'},
        ];
        if (format === 'pdf') {
            const blob = baseReportPdf({list, title: t(this.getListTitle()), columns, landscape: true}, this.props.t);
            return Promise.resolve(blob);
        } else if (format === 'csv') {
            const fields = [
                {value: 'firstName', label: t('driver.firstName')},
                {value: 'lastName', label: t('driver.lastName')},
                {value: 'pesel', label: t('driver.pesel')},
                {value: 'documentNumber', label: t('driver.documentNumber')},
            ];
            return Promise.resolve(baseReportCsv(list, fields));
        } else if (format === 'xlsx' || format === 'ods') {
            const request = {};
            request.columns = columns;
            request.list = list;
            request.sheetName = t(this.getListTitle()).replaceAll(/[*?\][\\/]/g, ' ,');
            return baseXLSXReport(request, format);
        }
    }
    renderCriteria() {
        const {t} = this.props;
        return (
            <div className='row'>
                <CriteriaTextComponent
                    id='lastName-sc'
                    name='lastName'
                    label={t('driver.lastName')}
                    colClass='col-xl-3 col-lg-6 col-md-6 col-sm-12'
                    value={this.state.criteria.lastName}
                    onChange={this.handleChangeSc}
                    validator={this.validator}
                    validators='not_required|alpha_space'
                    keyfilter={/^[A-ZĄĆĘŁŃÓŚŹŻąćęłńóśźż\s]*$/i}
                />
                <CriteriaTextComponent
                    id='pesel-sc'
                    name='pesel'
                    label={t('driver.pesel')}
                    colClass='col-xl-3 col-lg-6 col-md-6 col-sm-12'
                    value={this.state.criteria.pesel}
                    onChange={this.handleChangeSc}
                    validator={this.validator}
                    validators='not_required|numeric'
                    keyfilter={/^[0-9]*$/i}
                />
                <CriteriaTextComponent
                    id='documentNumber-sc'
                    name='documentNumber'
                    label={t('driver.documentNumber')}
                    colClass='col-xl-3 col-lg-6 col-md-6 col-sm-12'
                    value={this.state.criteria.documentNumber}
                    onChange={this.handleChangeSc}
                    validator={this.validator}
                    validators='not_required|alpha_num'
                    keyfilter={/^[A-ZĄĆĘŁŃÓŚŹŻąćęłńóśźż0-9]*$/i}
                />
                <CriteriaRadioButtonComponent
                    id='own-sc'
                    name='own'
                    colClass='col-xl-3 col-lg-6 col-md-6 col-sm-12'
                    viewMode='EDIT'
                    options={[
                        {name: 'true', label: t('driver.own-true')},
                        {name: 'false', label: t('driver.own-false')},
                    ]}
                    value={this.state.criteria.own}
                    valueLabel='label'
                    labelOnRight
                    valueKey='name'
                    itemColClass={'col-xl-6 col-lg-6 col-md-6 col-sm-6'}
                    onChange={this.handleChangeSc}
                    label={t('driver.own')}
                    validator={this.validator}
                    validators=''
                />
            </div>
        );
    }

    prepareColumns() {
        const {t} = this.props;
        return [
            {
                field: 'firstName',
                header: t('driver.firstName'),
                sortable: true,
            },
            {field: 'lastName', header: t('driver.lastName'), sortable: true},
            {field: 'pesel', header: t('driver.pesel'), sortable: true},
            {field: 'documentNumber', header: t('driver.documentNumber'), sortable: true},
            {
                key: 'own',
                field: 'own',
                className: 'hidden-column-in-driver-list',
            },

            {
                key: 'actions',
                header: t('list.actions'),
                body: this.actionTemplate,
                className: 'table-column-action'
            },
        ];
    }
    actionTemplate(rowData) {
        const {t} = this.props;
        return (
            <ActionLink
                label={t('details.editButton')}
                handleClick={this.handleOpenDialog.bind(this, rowData)}
                variant='blue'
                className='edit-blue-link'
                key={'view-button'}
            />
        );
    }
    prepareHeaderItems() {
        const {t} = this.props;
        return this.isUserInAnyRole('ROLE_WHOLESALE', 'ROLE_FRANCHISE', 'ROLE_ESPPOL')
            ? [
                  {type: 'LABEL', className: 'float-left'},
                  {
                      type: 'BUTTON',
                      className: 'right-side',
                      variant: 'white',
                      disabled: !this.state.selectedList || this.state.selectedList.length < 1,
                      customRenderFunction: this.renderPrintButton,
                  },
                  {
                      label: t('driver.addButton'),
                      onClick: this.handleOpenNewDialog,
                      type: 'BUTTON',
                      className: 'float-right',
                      variant: 'white',
                      iconSvg: 'ico_white_plus',
                      iconSide: 'left',
                  },
              ]
            : [];
    }
    handleOpenDialog(rowData, e) {
        if (e) {
            e.preventDefault();
        }
        this.setState({dialogVisibile: true, element: rowData, dialogViewMode: 'EDIT'});
    }
    handleOpenNewDialog(e) {
        if (e) {
            e.preventDefault();
        }
        this.setState({dialogVisibile: true, element: new DriverModel(), dialogViewMode: 'NEW'});
    }
    handleCloseDialog(e, callback) {
        if (e) {
            e.preventDefault();
        }
        this.setState({dialogVisibile: false, element: undefined}, () => {
            if (callback) callback();
        });
    }
    render() {
        const {t} = this.props;
        return (
            <div className='container-fluid driver-list-container'>
                {this.state.dialogVisibile ? (
                    <DriverDialog
                        key={`driver-dialog-${this.state.element?.pesel}`}
                        element={this.state.element}
                        onHide={(e) => this.handleCloseDialog(e)}
                        visible={this.state.dialogVisibile}
                        viewMode={this.state.dialogViewMode}
                        afterSave={(e) =>
                            this.handleCloseDialog(e, () => {
                                this.readMessage();
                                this.refreshTable();
                                this.unblockUi();
                            })
                        }
                        blockUi={this.blockUi}
                        unblockUi={this.unblockUi}
                        _isMounted={this._isMounted}
                    />
                ) : null}
                <BreadcrumbsItem to='/driver-list'>{t('driver.listName')}</BreadcrumbsItem>
                {this.renderView()}
            </div>
        );
    }
}

DriverList.defaultProps = {
    detailUrl: '/#/invoice/details',
    newUrl: '/#/invoice/create',
    lazy: false,
    disableSelection: false,
    selectionMode: 'multiple',
};

DriverList.propTypes = {
    detailUrl: PropTypes.string,
    newUrl: PropTypes.string,
};

export default withTranslation()(DriverList);
